import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Shell } from "@/components/Shell";
import { useT } from "@/i18n";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const { t } = useT();
  const [state, setState] = useState({ status: "polling", request_id: null });
  useEffect(() => {
    if (!sessionId) return setState({ status: "error" });
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState({ status: "paid", request_id: data.request_id, home_id: data.home_id, kind: data.kind });
        if (["expired", "failed"].includes(data.payment_status)) return setState({ status: "error", request_id: data.request_id });
      } catch (err) {
        if (err?.response?.status === 401) { setState({ status: "error" }); return; }
        // transient network error: polling continues below
      }
      if (++tries < 8) setTimeout(tick, 2000); else setState((s) => ({ ...s, status: "timeout" }));
    };
    tick();
  }, [sessionId]);
  const backTo = () => {
    if (state.kind === "plan365" && state.home_id) return `/app/casa/${state.home_id}`;
    if (state.request_id) return `/app/richieste/${state.request_id}`;
    return "/app";
  };
  return (
    <Shell>
      <div className="max-w-lg mx-auto card-craft p-10 text-center rise" data-testid="payment-result">
        {state.status === "polling" && <><Loader2 className="mx-auto animate-spin text-terracotta" size={40} /><h1 className="mt-4 font-serif text-3xl font-bold">{t("payment.verifying")}</h1><p className="mt-2 text-sm text-ink/60">{t("payment.wait")}</p></>}
        {state.status === "paid" && <><CheckCircle2 className="mx-auto text-forest" size={48} /><h1 className="mt-4 font-serif text-3xl font-bold" data-testid="payment-success-title">{t("payment.received")}</h1><p className="mt-2 text-sm text-ink/60">{t("payment.receivedText")}</p></>}
        {(state.status === "error" || state.status === "timeout") && <><XCircle className="mx-auto text-red-600" size={48} /><h1 className="mt-4 font-serif text-3xl font-bold">{t("payment.failTitle")}</h1><p className="mt-2 text-sm text-ink/60">{t("payment.failText")}</p></>}
        <Link to={backTo()} className="btn-primary mt-8" data-testid="payment-back-button">{state.kind === "plan365" ? t("payment.toFolder") : t("payment.toRequest")}</Link>
      </div>
    </Shell>
  );
}

export function PaymentCancel() {
  const [sp] = useSearchParams();
  const rid = sp.get("request_id");
  const { t } = useT();
  return (
    <Shell>
      <div className="max-w-lg mx-auto card-craft p-10 text-center rise" data-testid="payment-cancel">
        <XCircle className="mx-auto text-ink/40" size={48} /><h1 className="mt-4 font-serif text-3xl font-bold">{t("payment.cancelled")}</h1>
        <p className="mt-2 text-sm text-ink/60">{t("payment.cancelledText")}</p>
        <Link to={rid ? `/app/richieste/${rid}` : "/app"} className="btn-primary mt-8" data-testid="payment-cancel-back">{t("payment.toRequest")}</Link>
      </div>
    </Shell>
  );
}
